var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33331 6.66667C4.59693 6.66667 3.99998 7.26362 3.99998 8V24C3.99998 24.7364 4.59693 25.3333 5.33331 25.3333H26.6666C27.403 25.3333 28 24.7364 28 24V8C28 7.26362 27.403 6.66667 26.6666 6.66667H5.33331ZM1.33331 8C1.33331 5.79086 3.12417 4 5.33331 4H26.6666C28.8758 4 30.6666 5.79086 30.6666 8V24C30.6666 26.2091 28.8758 28 26.6666 28H5.33331C3.12417 28 1.33331 26.2091 1.33331 24V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54135 8.61822C1.93629 7.9967 2.76028 7.81303 3.3818 8.20797L15.3376 15.8053C15.5363 15.929 15.7658 15.9947 16 15.9947C16.2342 15.9947 16.4637 15.929 16.6625 15.8053C16.6635 15.8047 16.6645 15.8041 16.6655 15.8034L28.6183 8.20797C29.2398 7.81303 30.0638 7.9967 30.4587 8.61822C30.8536 9.23973 30.67 10.0637 30.0485 10.4587L18.0813 18.0632C17.4575 18.4541 16.7362 18.6613 16 18.6613C15.2639 18.6613 14.5426 18.454 13.9188 18.0632L13.9116 18.0587L1.95159 10.4587C1.33008 10.0637 1.14641 9.23973 1.54135 8.61822Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWhite);
export default __webpack_public_path__ + "static/media/mailWhite.7c138c38e1e796a2e1ddad85a1efe946.svg";
export { ForwardRef as ReactComponent };